import type { SiteStanding } from './useMe';
import { formatDate } from './time';

const OVERDUE_DAYS = 7;

/** What the standing banner says. Dates only: what happens after the grace is
 *  added in the change that switches mothball on (checklist 16.9.1), because a
 *  notice may not promise what does not yet happen. */
export function standingMessage(s: SiteStanding): string {
  const ends = formatDate(s.ends_at);
  if (s.cause === 'payment_overdue') {
    // `ends_at` is the day the payment reaches seven days overdue.
    const since = formatDate(s.ends_at - OVERDUE_DAYS * 86_400);
    return s.kind === 'ending'
      ? `A payment for this site has been overdue since ${since}. It will be seven days overdue on ${ends}.`
      : `A payment for this site has been overdue since ${since}, more than seven days.`;
  }
  if (s.kind === 'ending') {
    const days = s.days_remaining === 1 ? '1 day' : `${s.days_remaining} days`;
    return `This site's subscription ends on ${ends}, in ${days}.`;
  }
  return `This site's subscription ended on ${ends}.`;
}
